import { ControllerHelper, PostController, PostDownloadDto } from 'collaboration-service';
import { LoaderInline } from 'imaginarity-react-ui';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Actions } from 'services/ApplicationState/Actions';
import { RenderPost } from 'views/Feed/Feed';



interface PreviewMomentProps {
    id: string;
    context?: string;
}

const PreviewMoment = (p: PreviewMomentProps) => {
    const dispatch = useDispatch();
    const [post, setPost] = React.useState<PostDownloadDto>();
    const { id, context } = p;

    React.useEffect(() => {
        const load = async () => {
            if (id) {
                const p = context ?
                    await ControllerHelper.singleCall({ id, context }, PostController.GetSinglePostWithContext) :
                    await ControllerHelper.singleCall({ id }, PostController.GetSinglePost);
                setPost(p);
            }
        }
        load();
    }, [id, context]);

    const postChanged = React.useMemo(() => (post: PostDownloadDto) => {
        dispatch(Actions.updatePost(post));
    }, [dispatch]);


    if (post === undefined)
        return <LoaderInline active />;

    return (
        <div style={{ overflowX: "hidden", overflowY: "auto", scrollbarWidth: "none", padding: "1px 0", maxHeight: "calc(80vh - 100px)" }}>
            <RenderPost post={post} postChanged={postChanged} />
        </div>
    );
}
export default PreviewMoment;